import { useEffect } from "react";

export const useEffectOnce = (callback: () => void): void => {
  useEffect(callback, []);
};
